import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CurrencyPipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataDoctorArPaymentProcessorModel } from '../../../../models/accountsReceivable/data-doctor-ar-payment-processor.model';
import { DataARPaymentModel } from '../../../../models/accountsReceivable/data-ar-payment.model';
import { ITDOPaymentTransactionResult } from '@tdo-inc/tdo-payment';
import { PaymentAmountForDoctorModel } from '../../models/payment-amount-for-doctor.model';
import { CreatePaymentModel } from '../../models/create-payment.model';
import { ARService } from '../../ar.service';
import { Globals } from '../../../../globals';
import { CfgARPaymentMethodModel } from '../../../../models/accountsReceivable/cfg-ar-payment-method';
import { ArCardPaymentComponent } from '../ar-card-payment/ar-card-payment.component';
import { DataARClaimListModel } from '../../models/data-ar-claim-list';
import { ToastrService } from 'ngx-toastr';
import { TDOPrintService } from 'src/app/services/print/tdoprint.service';
import { PrintCCReceiptModel } from 'src/app/models/accountsReceivable/PrintCCReceipt.model';
import { ReportIDEnum } from 'src/app/models/enum/report-ID-enum';
import { PAYMENT_SOURCE } from 'src/app/models/constants/payment-source.model';
import { InsurancePaymentOverpayListModel } from '../../models/insurance-payment-overpay-list.model';
import { ArInsurancePaymentOverpayConfirmComponent } from '../ar-insurance-payment-overpay-confirm/ar-insurance-payment-overpay-confirm.component';
import { buildClaimItemOverpayList, clearUnavailablePatientPaymentActions, hasOverpaidItemWithoutAction } from '../insurance-payment-overpay.util';

@Component({
  standalone: false,
  selector: 'app-ar-insurance-payment-processor-total-confirm',
  templateUrl: './ar-insurance-payment-processor-total-confirm.component.html',
  styleUrls: ['./ar-insurance-payment-processor-total-confirm.component.scss']
})
export class ArInsurancePaymentProcessorTotalConfirmComponent implements OnInit {
  isLoading: boolean = false;
  claims: DataARClaimListModel[] = [];
  dataDoctorARPaymentProcessors: DataDoctorArPaymentProcessorModel[] = [];
  currentDataDoctorARPaymentProcessor: DataDoctorArPaymentProcessorModel;
  ispaymentLoading: boolean;
  currentDoctorPayment: PaymentAmountForDoctorModel;
  currentARPayment: DataARPaymentModel;
  
  enumCurrencyUSD: string = '00000192-1000-0000-0000-000000000001';
  enumPaymentTransactionTypeIDPurchase: string = '00000277-1000-0000-0000-000000000001';
  selectedPaymentMethod: CfgARPaymentMethodModel;
  arDocLocIds: any[];
  approvedPaymentAmount: number = 0;
  currentPatientID: string;
  isClaimRefusal: boolean = false;
  changesMade: boolean = false;
  isPrintingReceipt: boolean = false;
  insuranceOverPayDistributionList: InsurancePaymentOverpayListModel[] = [];
  insuranceClaimItemOverPayDistributionList: InsurancePaymentOverpayListModel[] = [];  
  paymentAmountNotDistributed: number = 0;

  constructor(public dialogRef: MatDialogRef<ArInsurancePaymentProcessorTotalConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly currencyPipe: CurrencyPipe,
    private readonly arService: ARService,
    private readonly globals: Globals,
    private readonly dialog: MatDialog,
    private readonly toastr: ToastrService,
    private readonly printService: TDOPrintService,
    private changeRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (this.data.totals) {
      this.dataDoctorARPaymentProcessors = this.data.totals;
      this.selectedPaymentMethod = this.data.paymentMethod;
      this.claims = this.data.claims;
      this.arDocLocIds = this.data.arAccounts;
      this.currentPatientID = this.data.patientId;
    }
    else
      this.currentPatientID = this.globals.currentPatientId;
  }

  cancelClick() {
    this.dialogRef.close(this.changesMade);
  }

  chargeCard(valPayDoc: DataDoctorArPaymentProcessorModel) {
    if (this.ispaymentLoading || valPayDoc.ChargeSuccess) {
      return;
    }
    // distributions are saved only after the charge succeeds, so validate the overpay actions before charging
    clearUnavailablePatientPaymentActions(this.claims);
    if (hasOverpaidItemWithoutAction(this.claims)) {
      this.createMessage('Select an action for overpaid claim items', 'Error');
      return;
    }
    this.submitPaymentValPay(valPayDoc);
  }


  async openPaymentReceipt(valPayDoc: DataDoctorArPaymentProcessorModel) {
    this.isPrintingReceipt = true;
    const paymentPrintParameters = new PrintCCReceiptModel();
    paymentPrintParameters.PatientID = this.currentPatientID;
    paymentPrintParameters.EnterpriseID = localStorage.getItem('TDOEnterpriseId');
    paymentPrintParameters.LOCID = this.globals.LOCID;
    paymentPrintParameters.TDOCID = localStorage.getItem('TDOCID');
    paymentPrintParameters.PaymentID = valPayDoc.PaymentID;
    // console.log('ArPaymentComponent openPaymentReceipt paymentPrintParameters: ', paymentPrintParameters);
    try {
      const documentID = await this.printService.printReport(ReportIDEnum.reportID_CreditCardReceiptReport, paymentPrintParameters).toPromise();
      this.printService.executePrint([documentID]);
      this.isPrintingReceipt = false;
    }
    catch (error) {
      this.createMessage('Error when trying to print Document.', 'error');
      this.isPrintingReceipt = false;
    }
  }

  submitPaymentValPay(valPayDoc: DataDoctorArPaymentProcessorModel) {
    if (this.ispaymentLoading || valPayDoc.ChargeSuccess) {
      return;
    }
    if (!valPayDoc.PaymentProcessorId) {
      this.createMessage('Payment Processor not found for selected account', 'Error');
      return;
    }
    this.ispaymentLoading = true;
    this.currentDataDoctorARPaymentProcessor = valPayDoc;

    this.currentDoctorPayment = new PaymentAmountForDoctorModel();
    this.currentDoctorPayment.PaymentProcessorId = valPayDoc.PaymentProcessorId;
    this.currentDoctorPayment.DoctorARLocId = valPayDoc.DoctorARLocId;
    this.currentDoctorPayment.amount = valPayDoc.PaymentAmountTotal;
    this.arDocLocIds.forEach(a => {
      if (a.DoctorARLocId === valPayDoc.DoctorARLocId) {
        this.currentDoctorPayment.ARAccountID = a.ARAccountID;
      }
    });

    const docAccount = this.arDocLocIds.find(a => a.DoctorARLocId === valPayDoc.DoctorARLocId);
    if (docAccount) {
      this.currentDoctorPayment.ARAccountID = docAccount.ARAccountID;
    }
    else {
      this.createMessage('AR Account not found for Doctor', 'Error');
      this.ispaymentLoading = false;
      return;
    }
    // console.log('ArPaymentComponent submitPayment payDr: ', this.currentDoctorPayment);

    this.createDataARPaymentRecord().then((newPayment: DataARPaymentModel) => {
      // console.log('ArPaymentComponent createDataARPaymentRecord result: ', newPayment);

      if (!newPayment) {
        this.ispaymentLoading = false;
        return;
      }
      valPayDoc.PaymentID=newPayment.PaymetnID;

        // cfgARPayment record created
        // record new payment
        this.currentARPayment = newPayment;

        // if electronic
        newPayment.PaymentProcessorId = this.currentDoctorPayment.PaymentProcessorId;

        this.openCardPaymentComponentNew(newPayment)
          .then((result: ITDOPaymentTransactionResult) => {
            if (result?.success) {
              this.approvedPaymentAmount = result.data.amount;
              this.changesMade = true;

              // payment made, now create distributions that have already been determined
              // the ValPay webhook posts the payment's ledger row, so it isn't created here
              this.savePaymentDistributionBalanceCheck();


              // set payment to successful
              this.dataDoctorARPaymentProcessors.forEach(pp => {
                if (pp.DoctorARLocId === valPayDoc.DoctorARLocId) {
                  pp.ChargeSuccess = true;
                }
              });
            }
            this.ispaymentLoading = false;
            this.changeRef.detectChanges();
          }, err => {
            this.createMessage('Something went wrong', 'Error');
            this.ispaymentLoading = false;
            console.error(err);
            this.changeRef.detectChanges();
          });
    }, err => {
      this.createMessage('Something went wrong', 'Error');
      this.ispaymentLoading = false;
      console.error(err);
      this.changeRef.detectChanges();
    });
  }

  createDataARPaymentRecord() {
    const promise = new Promise((resolve, reject) => {
      const createPayment = new CreatePaymentModel();

      const currDate = new Date();
      createPayment.datePostPayment = currDate;
      createPayment.dateReceivedPayment = currDate;
      createPayment.Description = 'ValPay Credit Payment';
      createPayment.enumPaymentSourceID = PAYMENT_SOURCE.Insurance;
      createPayment.PatientID = this.currentPatientID;
      createPayment.paymentAmount = this.currentDoctorPayment.amount;
      createPayment.PaymentFrom = null;
      createPayment.PaymentFromContactID = null;
      createPayment.enumCurrencyID = this.enumCurrencyUSD;
      createPayment.DepositARAccountID = this.currentDoctorPayment.ARAccountID;
      createPayment.enumPaymentTransactionTypeID = this.enumPaymentTransactionTypeIDPurchase;
      createPayment.LOCID = this.globals.LOCID;
      createPayment.PaymentProcessorID = this.currentDoctorPayment.PaymentProcessorId;

      // console.log('createDataARPaymentRecord selectedpaymentmethod: ', this.selectedPaymentMethod);
      if (this.selectedPaymentMethod) {
        createPayment.enumARPayementCCTypeID = this.selectedPaymentMethod.enumARPayementCCTypeID ? this.selectedPaymentMethod.enumARPayementCCTypeID : null;
        createPayment.enumARPayementETypeID = this.selectedPaymentMethod.enumARPayementETypeID ? this.selectedPaymentMethod.enumARPayementETypeID : null;
        createPayment.enumARPayementTypeID = this.selectedPaymentMethod.enumARPayementTypeID ? this.selectedPaymentMethod.enumARPayementTypeID : null;
      }

      this.arService.createDataARPaymentRecord(createPayment)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  openCardPaymentComponentNew(payment: DataARPaymentModel) {

    // console.log('ArPaymentComponent openCardPaymentComponentNew payment: ', payment);
    const promise = new Promise((resolve, reject) => {

      const LOCID = localStorage.getItem('LOCID');
      const dialogRef = this.dialog.open(ArCardPaymentComponent, {
        width: '650px',
        height: '760px',
        maxHeight: '95vh',
        disableClose: true,
        panelClass: 'dialog',
        data: {
          paymentAmount: payment.PaymentAmount,
          invoiceId: '',
          LOCID,
          arPayment: payment,
          paymentFrom: 'insurance payment',
          accountDescription: this.returnARAccountNameById(this.currentDoctorPayment.ARAccountID),
          paymentProcessorID: payment.PaymentProcessorId
        }
      });
      dialogRef.afterClosed().subscribe(result => {

        resolve(result);
      }, err => {
      });

    });
    return promise;
  }

  returnARAccountNameById(ARAccountID: string) {
    let ARAccountName: string = '';
    this.arDocLocIds.forEach(a => {
      if (a.ARAccountID === ARAccountID) {
        ARAccountName = a.AccountName;
      }
    });
    return ARAccountName;
  }

  createMessage(message, type) {
    if (type.toLowerCase() === "error")
      this.toastr.error(message, null, { timeOut: 7000 });
    else if (type.toLowerCase() === "warning")
      this.toastr.warning(message, null, { timeOut: 5000 });
    else
      this.toastr.success(message, null, { timeOut: 5000 });
  }

    async savePaymentDistributionBalanceCheck() {
      // if there is any amount undistributed, show dialog asking if user wants to credit that amount, or continue distributing
      this.insuranceOverPayDistributionList = [];
      this.insuranceClaimItemOverPayDistributionList = [];
      let paymentsDistributed = 0;

      // check for over-distributed claim items
      this.claims.forEach(claim => {
        claim.dataARClaimListItems.forEach(claimItem => {
          if (claimItem.ApplyPayment > 0 && claimItem.ApplyPayment > claimItem.AmountOutstanding) {
            // add to list of over-payments to credit
            this.insuranceClaimItemOverPayDistributionList.push(
              ...buildClaimItemOverpayList(claim, claimItem, this.currentARPayment.PaymetnID));
          }
          paymentsDistributed += claim.ApplyPayment;
        });
      });
  
      this.paymentAmountNotDistributed = this.currentDoctorPayment.amount - paymentsDistributed;

      if (this.paymentAmountNotDistributed > 0) {
  
        // handle overpay distribution list
        //let patientClaims: DataARClaimListModel[] = this.claims;
        this.claims.forEach(c => {
          const dist = new InsurancePaymentOverpayListModel();
          dist.PatientID = c.PatientID;
          dist.PatientName = c.PatientFirstName + ' ' + c.PatientLastName;
          dist.Amount = 0;
          dist.ClaimNumber = c.TDOClaimNumber;
          this.insuranceOverPayDistributionList.push(dist);
        });
  
        // setup dialog
        const config = new MatDialogConfig();
        config.width = '450px';
        config.height = '400px';
        config.data = {
          overPayAmount: this.paymentAmountNotDistributed,
          overPayAmountList: this.insuranceOverPayDistributionList
        };
        config.panelClass = 'dialog';
  
        // open dialog
        const popup = this.dialog.open(ArInsurancePaymentOverpayConfirmComponent, config);
        popup.afterClosed().subscribe(result => {
          // return result
          if (result.length > 0) {
            // move ahead with credit
            this.insuranceOverPayDistributionList = result;
            this.savePaymentDistributionClicked();

          }
        });
      }
      else {
        this.savePaymentDistributionClicked();
      }
    }

  savePaymentDistributionClicked() {
    this.isLoading = true;

    // get claims to save
    const claimsToSave: DataARClaimListModel[] = [];
    this.claims.forEach(claim => {

      // need to filter claims by current DoctorARLocID!!

      // only look at claims with an amount applied
      if (claim.ApplyPayment > 0 && claim.DoctorARLocId === this.currentDataDoctorARPaymentProcessor.DoctorARLocId) {

        // get total of applied amounts of other claim items for claim
        let claimItemsApplyTotal = 0;
        claim.dataARClaimListItems.forEach(claimitemSum => {
          claimItemsApplyTotal += claimitemSum.ApplyPayment;
        });

        // if total claim item apply amounts = total claim apply amount, then we can save the claim
        if (claimItemsApplyTotal === claim.ApplyPayment) {
          claimsToSave.push(claim);
        }
      }
    });

    if (claimsToSave.length) {
      // prevent apply amounts from exceeding amount owed/outstanding
      // any overpayments will be handled on the server in the call below
      claimsToSave.forEach(a => {
        a.dataARClaimListItems.forEach(b => {
          if (b.ApplyPayment > b.AmountOutstanding){
            b.ApplyPayment = b.AmountOutstanding;
          }
        });
      });
      this.savePaymentDistribution(claimsToSave).then((result: number) => {
        if (result) {
          if (result === 1) {
            this.createMessage('Insurance payment distribution succeeded', 'Success!');
          }
        }
        this.isLoading = false;
        this.changeRef.detectChanges();
      }, err => {
        this.createMessage('Problem distributing insurance payment', 'Error');
        this.isLoading = false;
        this.changeRef.detectChanges();
      });
    }
    else {
      this.isLoading = false;
      this.changeRef.detectChanges();
    }

    // hide charge button
    this.currentDataDoctorARPaymentProcessor.ChargeSuccess = true;
  }

  savePaymentDistribution(claims: DataARClaimListModel[]) {
    const promise = new Promise((resolve, reject) => {
      this.arService.saveInsurancePaymentDistributions(claims, this.currentARPayment.PaymetnID, this.insuranceOverPayDistributionList, this.insuranceClaimItemOverPayDistributionList, this.currentPatientID, this.isClaimRefusal)
        .subscribe(resolve, reject);
    });
    return promise;
  }
}
